import { ll } from "../core/ll";

export function newLoadingMask(args) {
    var instructions = args.instructions || "",
        loadingImage = args.loadingImage == undefined ? true : args.loadingImage;

    var loadingHtml = "<div class='grid-instructions-container k-loading-mask'>";

    if (loadingImage) {
        loadingHtml += "<div class='k-loading-image'></div>";
    }

    loadingHtml += "<div class='grid-instructions'>" + instructions + "</div>" +
        '<div class="z-still-loading">' + ll("StillLoading") + "</div>" +
        "<div class='k-loading-color'></div>" +
        "</div>";

    return loadingHtml;
}

export function maskElements(args) {
    args = args || {};
    if (args.bindClass && args.container) {
        var objects = $(args.container).find(args.bindClass).filter(":not(.pane-field-number)");

        $.each(objects, function (index, object) {
            var elem = $(object);
            if (elem.attr("data-bind")) {
                if (elem.data("me") && elem.data("me").options) {
                    var type = elem.data("me").options.type;

                    switch (type) {
                        case "TextBox":
                        case "AutoComplete":
                        case "ComboBox":
                        case "DateTimeInput":
                        case "DateInput":
                        case "TimeInput":
                        case "NumericInput":
                            elem.parents(".pane-field-input").mask({ inputMask: true, marginTop: "0" });
                            break;
                        case "Check":
                            elem.parent().find(".checkbox-label").addClass("app-small-spinner");
                            break;
                        case "PaneIconLink":
                            elem.find(".bind-value").addClass("app-small-spinner");
                            break;
                        case "Label":
                        case "LabelLabel":
                        case "LabelLink":
                        default:
                            elem.addClass("app-small-spinner");
                            break;
                    }
                } else {
                    if (elem.parents(".label-group-container").length > 0) {
                        elem.parents(".label-group-container").addClass("app-small-spinner");
                    } else {
                        elem.addClass("app-small-spinner");
                    }
                }
            }
        });
    }
}

export function unmaskElements(args) {
    args = args || {};
    if (args.bindClass && args.container) {
        var objects = $(args.container).find(args.bindClass);
        $.each(objects, function (index, object) {
            var elem = $(object);
            if (elem.attr("data-bind")) {
                if (elem.data("me") && elem.data("me").options) {
                    var type = elem.data("me").options.type;

                    switch (type) {
                        case "TextBox":
                        case "AutoComplete":
                        case "ComboBox":
                        case "DateTimeInput":
                        case "DateInput":
                        case "TimeInput":
                        case "NumericInput":
                            elem.parents(".pane-field-input").unmask();
                            break;
                        case "Check":
                            elem.parent().find(".checkbox-label").removeClass("app-small-spinner");
                            break;
                        case "PaneIconLink":
                            elem.find(".bind-value").removeClass("app-small-spinner");
                            break;
                        case "Label":
                        case "LabelLabel":
                        case "LabelLink":
                        default:
                            elem.removeClass("app-small-spinner");
                            break;
                    }
                } else {
                    if (elem.parents(".label-group-container").length > 0) {
                        elem.parents(".label-group-container").removeClass("app-small-spinner");
                    } else {
                        elem.removeClass("app-small-spinner");
                    }
                }
            }
        });
    }
}
